import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  GET_MEDICARE_METRICS_OVERVIEW_REQUEST: '',
  GET_MEDICARE_METRICS_OVERVIEW_SUCCESS: '',
  GET_MEDICARE_METRICS_OVERVIEW_FAILURE: '',

  UPDATE_MEMBER_MEASURE_REQUEST: '',
  UPDATE_MEMBER_MEASURE_SUCCESS: '',
  UPDATE_MEMBER_MEASURE_FAILURE: '',

  GET_EMCODES_REQUEST: '',
  GET_EMCODES_SUCCESS: '',
  GET_EMCODES_FAILURE: '',
};

types = setStoreTypeValues(types, 'measure');

export default types;
